import React from 'react'
import { makeStyles } from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import HMapButton from '../../components/HMapButton'

const HMapDetailsFooter = ({ text, onCanel, onSubmit }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <HMapButton
        className={classes.saveCancelButton}
        text="Cancel"
        secondaryButton={false}
        onClick={onCanel}
      />
      <HMapButton
        className={classes.saveCancelButton}
        text="Cancel"
        secondaryButton={false}
        onClick={onSubmit}
      >
        <AddIcon className={classes.iconButton} /> {text || "Create Heatmap"}
      </HMapButton>
    </div>
  )
}

export default React.memo(HMapDetailsFooter)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 15px',
    boxShadow: '0px -3px 6px 0px rgba(0, 0, 0, 0.08)'
  },
  saveCancelButton: {
    backgroundColor: theme.palette.quaternary.accent,
    color: theme.palette.tertiary.main,
    borderColor: theme.palette.quaternary.accent
  },
  iconButton: {
    marginRight: '5px'
  }
}))
